import { defineStore } from 'pinia'

function toDate (value) {
    if (typeof value == 'string') {
        if (isNaN(Date.parse(value))) return false;
        return new Date(value);
    }
    if (!(value instanceof Date) || isNaN(value.getTime())) return false;
    return value;
}

export const useEventStore = defineStore({
    id: 'event',

    state () {
        return {
            slug:      null,
            event:     {},
            card:      null,
            module:    {},
            accesses:  null,
            hydrated:  false,
            hydrating: false,
        };
    },

    getters: {
        eventState (state) {
            // No start date, event in early stages of planning
            if (!state?.event?.startDate) return 'upcoming';

            const now   = new Date();
            const start = toDate(state.event.startDate);

            // Invalid start date, assume event in future
            if (!start) return 'upcoming';

            const hours = Math.round((start - now) / 1000 / 60 / 60);

            if (hours > 24) return 'upcoming';
            if (hours > 0 || start > now) return 'coutdown';

            // Do video check before end date check, since video means event finished
            const video = state?.module?.lections?.length
                && state.module.lections[0];

            if (video) return 'video';

            let end = toDate(state?.event?.endDate);
            if (!end) {
                // No end date, assume event takes 2 hours
                end = new Date(start);
                end.setHours(end.getHours() + 2);
            }

            if (now <= end) return 'ongoing';
            if (state?.event?.recordingPending) return 'editing';
            return 'finished';
        },

        type (state) {
            if (state?.module?.type) {
                const { type } = state.module;
                if (type == 'practice') return 'workshop';
                if (type == 'theory') return 'lecture';
            }
            return 'event';
        },
    },

    actions: {
        async hydrate (slug) {
            if (!this.hydrating) {
                this.hydrating = new Promise(async (resolve, reject) => {
                    const data = await this.$nuxt.$axios.$get(`/course/get`, {
                        params:   { slug },
                        progress: false,
                    })
                    .catch(error => {
                        return reject(error);
                    });

                    this.slug     = slug;
                    this.event    = data?.course || {};
                    this.module   = data?.modules?.length && data.modules[0] || {};
                    this.card     = data?.card;
                    this.accesses = data?.accesses;

                    this.hydrated  = true;
                    this.hydrating = false;

                    return resolve(true);
                });
            }

            return this.hydrating;
        },
    },
});
